export const siteConfig = {
    name: "LaunchHero.fyi",
    url: "https://ui.shadcn.com",
    ogImage: "https://ui.shadcn.com/og.jpg",
    description:
        "A set of beautifully-designed, accessible components and a code distribution platform. Works with your favorite frameworks. Open Source. Open Code.",
    links: {
        twitter: "https://twitter.com/shadcn",
        github: "https://github.com/shadcn-ui/ui",
    },
    lastUpdated: "May 1, 2025",
    contactEmail: "hello@launchhero.fyi",
};

export const META_THEME_COLORS = {
    light: "#ffffff",
    dark: "#09090b",
};
